export function getNumbersMinMax(numbers) {
  return numbers.reduce((acc, val) => {
    acc[0] = acc[0] === undefined || val < acc[0] ? val : acc[0];
    acc[1] = acc[1] === undefined || val > acc[1] ? val : acc[1];
    return acc;
  }, []);
}

export const isGraphicGif = name => name.includes('.gif');
